import classnames from 'classnames';
import { Image } from "../../Image/Image/Image";
import { Text } from "../../Text/Text/Text";
import styles from "./ArticleImage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ArticleImage = function ArticleImage(_ref) {
  var imageDesktop = _ref.imageDesktop,
    imageMobile = _ref.imageMobile,
    alt = _ref.alt,
    caption = _ref.caption,
    byLine = _ref.byLine;
  if (!imageDesktop) {
    return null;
  }
  return /*#__PURE__*/_jsxs("figure", {
    className: styles.imagesWrapper,
    children: [/*#__PURE__*/_jsx(Image, {
      className: classnames(styles.image, styles.imageDesktop),
      src: imageDesktop,
      alt: alt,
      loading: 'eager',
      width: '800',
      height: '400'
    }), /*#__PURE__*/_jsx(Image, {
      className: classnames(styles.image, styles.imageMobile),
      src: imageMobile ? imageMobile : imageDesktop,
      alt: alt
    }), (caption || byLine) && /*#__PURE__*/_jsxs("figcaption", {
      className: styles.captionWrapper,
      children: [caption && /*#__PURE__*/_jsx(Text, {
        typog: "bodycopy",
        textElement: "span",
        className: styles.caption,
        children: caption
      }), byLine && /*#__PURE__*/_jsx(Text, {
        typog: "bodycopySmall",
        textElement: "span",
        children: byLine
      })]
    })]
  });
};